var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useField, useFormikContext } from "formik";
import React from "react";
export var FormItemDebet = function (_a) {
    var name = _a.name, label = _a.label, tooltip = _a.tooltip;
    var _b = useFormikContext(), submitForm = _b.submitForm, setFieldValue = _b.setFieldValue;
    var _c = __read(useField(name), 2), field = _c[0], meta = _c[1];
    var touched = meta.touched, error = meta.error;
    var selectedValue = field.value;
    var errorText = touched && error ? error : null;
    var handleChange = function (value) {
        setFieldValue(name, value);
        // submitForm();
    };
    var parse = function (number) {
        console.log(number, "number");
        var x = number.replaceAll(",", '.').replaceAll(' ', '');
        console.log(x, "x");
        var result = parseFloat(x);
        console.log(result, "result");
        return isNaN(result) ? '' : result.toString();
    };
    return (React.createElement("div", { className: "form-item-debet" },
        React.createElement("div", { className: "form-item-debet__label_box" },
            React.createElement("label", { className: "form-item-debet__label" }, label),
            tooltip ? (React.createElement("div", { className: "form-item-debet__tooltip" },
                "i",
                React.createElement("div", { className: "form-item-debet__tooltip_window tooltip" }, tooltip))) : (React.createElement(React.Fragment, null))),
        React.createElement("div", { className: "form-item-debet__control_wrapper" },
            React.createElement("input", { className: "form-item-debet__control", 
                // id={`${name}_${value}`}
                type: "number", step: "0.01", name: name, onChange: function (event) { return handleChange(event.target.value); }, value: selectedValue !== null && selectedValue !== void 0 ? selectedValue : (0).toFixed(2) }),
            React.createElement("div", { className: "form-item-debet__currency" }, "K\u010D")),
        errorText && (React.createElement("div", { className: "form-item-textarea__error scroll_to_error" }, errorText))));
};
